import $ from 'jquery'
import { DROP_DOWN } from '@namespace/common/dropDown'
// import { FADE_UP } from '@namespace/common/fadeUp'
import { RANGE_SP } from '@namespace/common/rangeSp'
import { UA_TABLET } from '@namespace/common/uaTablet'
import { UA_CLASS } from '@namespace/common/uaClass'
import { GNAV } from '@namespace/common/gnav'
// import { HEADING_DIV } from '@namespace/common/headingDiv'
// import { MV_MOVIE } from '@namespace/common/mvMovie'
import { LOCATION_CHECK } from '@namespace/common/locationCheck'
import { SMOOTH_SCROLL } from '@namespace/common/smoothScroll'
import { SCROLL_TOP } from '@namespace/common/scrollTop'
import { SEPARATE_WITH_SPAN } from '@namespace/common/separateWithSpan'
import { GALLERY_LIGHTBOX } from '@namespace/common/galleryLightbox'
import { OBSERVER } from '@namespace/common/observer'
// import { SWIPER } from '@namespace/common/swiper'

export default function common() {
  const GLOBALSITE = {
    COMMON: {
      VARIABLES: {
        range_sp: true,
      },
      init: function () {
        this.DROP_DOWN.init()
        // this.FADE_UP.init()
        this.RANGE_SP.init(this.VARIABLES)
        this.UA_TABLET.init()
        this.UA_CLASS.init()
        this.GNAV.init(GLOBALSITE)
        // this.HEADING_DIV.init()
        // this.MV_MOVIE.init()
        this.OBSERVER.init()
        this.LOCATION_CHECK.init()
        this.SMOOTH_SCROLL.init()
        this.SCROLL_TOP.init()
        this.SEPARATE_WITH_SPAN.init()
        this.GALLERY_LIGHTBOX.init('[id^="gallery"]')
        this.GALLERY_LIGHTBOX.init('.wp-block-gallery > .wp-block-image')
        // this.SWIPER.init()
      },
      DROP_DOWN,
      // FADE_UP,
      OBSERVER,
      RANGE_SP,
      UA_TABLET,
      UA_CLASS,
      GNAV,
      // HEADING_DIV,
      // MV_MOVIE,
      LOCATION_CHECK,
      SMOOTH_SCROLL,
      SCROLL_TOP,
      SEPARATE_WITH_SPAN,
      GALLERY_LIGHTBOX,
      // SWIPER,
    },
  }

  $(function () {
    GLOBALSITE.COMMON.init()
  })
  $(window).on('load', function () {
    $('body').addClass('initialized')
  })
}
